import { Container, Button, Text, Card } from "../../../components";
import Localization from "../../../localization";
import { AuthLayout } from "../../../layouts";
import React, { useRef } from "react";
import { SVGs } from "../../../assets";
import { Flex } from "antd";

const UnAuth = () => {
  const authLayoutRef = useRef();

  return (
    <Container>
      <Card title={Localization.activate.unauth_title}>
        <Flex gap={"1.5rem"}>
          <img className="w-20" src={SVGs.balloons} />
          <Text type="secondary" children={Localization.activate.unauth_desc} />
        </Flex>
        <Button
          type="primary"
          className="m-30-t"
          title={Localization.dashboard.card_1_btn}
          onClick={() => authLayoutRef.current.login.open()}
        />
      </Card>
      <AuthLayout ref={authLayoutRef} />
    </Container>
  );
};

export default UnAuth;
